import FilterRange from './FilterRange';
import parseRangeRawKey from '@/app/utils/parseRangeRawKey';

class FilterDate extends FilterRange {
  constructor(conf, subcategory) {
    super(conf, subcategory);
  }

  init() {
    this.value = {
      from: null,
      to: null,
    };
    super.init();
  }

  collectValues() {
    return {
      ...this.#buildCollectedValuesField('after', this.value.from),
      ...this.#buildCollectedValuesField('before', this.value.to),
    };
  }

  resetValue = () => {
    this.value = {
      from: null,
      to: null,
    };
  };

  validate() {
    return { valid: true, errors: {} };
  }

  async apply(_, keysMap) {
    this.value = { from: null, to: null };
    for (let key in keysMap) {
      this.value[parseRangeRawKey(key)] = keysMap[key];
    }
  }

  #buildCollectedValuesField(key, value) {
    return {
      [`${this.property}[${key}]`]: value || null,
    };
  }
}

export default FilterDate;
